export enum NodeType {
  TRIGGER = "TRIGGER",
  ACTION = "ACTION",
  CONDITION = "CONDITION",
  TRANSFORMER = "TRANSFORMER",
  CUSTOM = "CUSTOM",

  // Facebook specific node types
  FACEBOOK_CREATE_POST = "FACEBOOK_CREATE_POST",
  FACEBOOK_GET_POSTS = "FACEBOOK_GET_POSTS",
  FACEBOOK_UPDATE_POST = "FACEBOOK_UPDATE_POST",
  FACEBOOK_DELETE_POST = "FACEBOOK_DELETE_POST"
}

export enum EdgeType {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
  CONDITION = "CONDITION",
  DEFAULT = "default"
}

export interface Workflow {
  id: string;
  name: string;
  description: string;
  isActive: boolean;
  enabled: boolean;
  steps: WorkflowStep[];
  nodes: WorkflowNode[];
  edges: WorkflowEdge[];
  createdAt: string;
  updatedAt: string;
  schedule?: string;
}

export interface WorkflowStep {
  id: string;
  type: NodeType;
  name: string;
  description: string;
  config: Record<string, any>;
}

export interface WorkflowNode {
  id: string;
  type: NodeType;
  name: string;
  description: string;
  config: Record<string, any>;
  position: {
    x: number;
    y: number;
  };
  data: {
    label: string;
    type: string;
  };
}

export interface WorkflowEdge {
  id: string;
  source: string;
  target: string;
  type: EdgeType | "default";
  label?: string;
  sourceHandle?: string | null;
  targetHandle?: string | null;
  animated?: boolean;
}

export enum ExecutionStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED"
}

export interface WorkflowExecution {
  id: string;
  workflowId: string;
  status: ExecutionStatus;
  startedAt: string;
  completedAt?: string;
  error?: string;
  input?: Record<string, any>;
  output?: Record<string, any>;
  logs?: string[];
}
